if (!customElements.get('announcement-bar')) {
    class AnnouncementBar extends HTMLElement {
        constructor() {
            super();
        }

        /**
         * When the bar is loaded, hide the skeleton bar
         */
        connectedCallback() {
            let skeletonText = this.querySelectorAll('.utility-bar-skeleton__text');
            skeletonText.forEach((txt) => {
                txt.style.display = 'none';
            });
            this._campaignSessionHandler = () => this.updateSingleAnnouncementVisibility();
            document.addEventListener('readers:campaign-session-change', this._campaignSessionHandler);
            this.updateSingleAnnouncementVisibility();
        }

        disconnectedCallback() {
            document.removeEventListener('readers:campaign-session-change', this._campaignSessionHandler);
        }

        /**
         * Applies date, login and campaign targeting when there is only one announcement block.
         */
        updateSingleAnnouncementVisibility() {
            const singleAnnouncement = this.querySelector('.announcement-bar--one-announcement');
            if (!singleAnnouncement || typeof SchedulingUtils === 'undefined') return;

            const isDateBetweenScheduleContent = DateUtils.checkDateBetween(
                singleAnnouncement.dataset.timezone,
                singleAnnouncement.dataset.dateFrom,
                singleAnnouncement.dataset.dateTo
            );
            const isUserLogged = singleAnnouncement.dataset.customer != '';
            const campaignMatch = SchedulingUtils.getCampaignMatch(singleAnnouncement);
            const removeElement = SchedulingUtils.checkIfRemoveItem(
                isUserLogged,
                singleAnnouncement.dataset.loggedRequired == 'true',
                false,
                campaignMatch,
                campaignMatch.required && campaignMatch.matches,
                isDateBetweenScheduleContent
            );

            if (removeElement) {
                singleAnnouncement.remove();
                document.removeEventListener('readers:campaign-session-change', this._campaignSessionHandler);
                return;
            }

            singleAnnouncement.style.display = 'block';
        }
    }
    customElements.define('announcement-bar', AnnouncementBar);
}